export default {
  kpus: [],
  projectLeaders : [],
  keyProjectTypes : [],
  keyProjects : []
}
